// extracted by css-extract-rspack-plugin
module.exports =  {"separator":"Separator__separator--Rlos9"};